import { FC, useState } from "react";

import { BaseModal } from "@/components/BaseModal";
import FlexContainer from "@/components/FlexContainer";
import { SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch } from "@/hooks/redux";
import { useMakeCommand } from "@/hooks/useRequestQueue";
import { enqueueRequestQueueItem } from "@/store/slices/offline";
import { setTaskCompleted } from "@/store/slices/work";
import { ModalPayloads, ModalType } from "@/types/modals";

import { StyledWarningIcon } from "./Styled";

interface StartVisitModalWarningProps {
    onCloseModal: () => void;
    payload: ModalPayloads[ModalType.StartVisitWarning];
}

export const StartVisitModalWarning: FC<StartVisitModalWarningProps> = ({
    payload,
    onCloseModal,
}) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const { market, taskId, coords } = payload;

    const { makeTaskCompleteCommands } = useMakeCommand();

    const handleConfirm = async () => {
        setLoading(true);

        const taskCompleteCommands = await makeTaskCompleteCommands({
            params: {
                taskId,
                hasPhoto: false,
                payload: { coords },
            },
            marketId: market.id,
            coords,
        });

        dispatch(
            enqueueRequestQueueItem({
                id: taskId,
                metadata: { marketId: market.id, taskId },
                commands: taskCompleteCommands,
            }),
        );

        dispatch(
            setTaskCompleted({
                marketId: market.id,
                taskId,
            }),
        );

        onCloseModal();
    };

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            onConfirm={handleConfirm}
            title="Увага!"
            description="Ви розпочинаєте візит поза зоною торгової точки, якщо ви продовжите, це буде зафіксовано у звіті про виконання задач."
            confirmText="Продовжити"
            cancelText="Скасувати"
            icon={<StyledWarningIcon>!</StyledWarningIcon>}
            confirmLoading={loading}
            maskClosable={!loading}
        >
            <FlexContainer alignItems="flex-start" flexDirection="column">
                <SecondaryText>
                    Відстань до торгової точки — {payload.dist} км.
                </SecondaryText>
                <SecondaryText>Максимально допустима — 500 м.</SecondaryText>
            </FlexContainer>
        </BaseModal>
    );
};
